/**
 * Состав пака «bright-pop» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 28 воронок: группы.json, группы 13 (PACK в matrix.py)
  palettes: [
    // 4 из 28 воронок: palette → ближайшая тема по цветам
    { themeId: 'cream-editorial', weight: 0.14 },
    // 4 из 28 воронок: palette → ближайшая тема по цветам
    { themeId: 'forest-green', weight: 0.14 },
    // 3 из 28 воронок: palette → ближайшая тема по цветам
    { themeId: 'study-blue', weight: 0.11 },
  ],
  fonts: [
    // 23 из 28 воронок: fontId
    { fontId: 'inter', weight: 0.82 },
    // 2 из 28 воронок: fontId
    { fontId: 'poppins', weight: 0.07 },
  ],
  screenKinds: [
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.449; сюда свёрнуты Q10, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.52 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.084
    { kind: 'I1', share: 0.1 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.073
    { kind: 'N8', share: 0.09 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.065
    { kind: 'Q2', share: 0.08 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.061
    { kind: 'N5', share: 0.07 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.054
    { kind: 'N1', share: 0.06 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.037; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.04 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.034; сюда свёрнуты Q16 (замена из arsenal.mjs)
    { kind: 'N4', share: 0.04 },
  ],
  blocks: [
    // в 24 из 28 воронок (признаки.json blocks), подъём 1.90; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 69 из 137
    {
      type: 'multiple_choice',
      weight: 0.86,
      settings: { optionIndicator: 'none' },
    },
    // в 28 из 28 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 315 из 370, optionIndicator 335 из 370
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 23 из 28 воронок (признаки.json blocks), подъём 1.72
    { type: 'loader_processing', weight: 0.82, settings: {} },
    // в 21 из 28 воронок (признаки.json blocks), подъём 1.86
    { type: 'email', weight: 0.75, settings: {} },
    // в 10 из 28 воронок (признаки.json blocks), подъём 2.50; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): testimonialQuoteMarks 20 из 21
    {
      type: 'testimonials',
      weight: 0.36,
      settings: { testimonialQuoteMarks: true },
    },
    // в 9 из 28 воронок (признаки.json blocks), подъём 1.97
    { type: 'name_field', weight: 0.32, settings: {} },
    // в 10 из 28 воронок (признаки.json blocks), подъём 1.58; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 14 из 16
    { type: 'image_choice', weight: 0.36, settings: { autoAdvance: true } },
  ],
  niches: [
    // 4 из 28 воронок (признаки.json theme)
    { niche: 'mental_health', weight: 0.14 },
    // 3 из 28 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.11 },
    // 3 из 28 воронок (признаки.json theme)
    { niche: 'nutrition', weight: 0.11 },
    // 3 из 28 воронок (признаки.json theme)
    { niche: 'language_learning', weight: 0.11 },
  ],
};
